<template>
  <div>
    <div style="width: 100%; text-align: center;">
      <h3>基本信息</h3>
    </div>
    <a-form-model :model="modelData" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 }, }" ref="ruleForm" :rules="rules">
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="schemeName" label="方案名称">
            <a-input placeholder="请输入方案名称" v-model="modelData.schemeName" class="input" style="width: 233%;"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="所属科室" prop="departmentId">
            <a-select placeholder="请选择科室" v-model="modelData.departmentId" showSearch :filterOption="filterOption"
              @change="deptChange(false)">
              <a-select-option :value="item.id" v-for="(item, index) in deptList" :key="index">{{ item.name
                }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="所属亚专业" prop="subSpecialtyId">
            <a-select placeholder="请选择亚专业" v-model="modelData.subSpecialtyId" showSearch :filterOption="filterOption"
              @change="subMajorChange(false)">
              <a-select-option :value="item.id" v-for="(item, index) in subMajorList" :key="index">{{ item.name
                }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="所属病种" prop="diseaseTypeId">
            <a-select placeholder="请选择病种" v-model="modelData.diseaseTypeId" showSearch :filterOption="filterOption" @change="diseaseChange(false)" style="width: 233%;">
              <a-select-option :value="item.id" v-for="(item, index) in diseaseList" :key="index">{{ item.name
                }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="plannedGroupSize" label="入组人数">
            <a-input placeholder="请输入入组人数" v-model="modelData.plannedGroupSize" class="input"/>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="dailyEntryCount" label="每天入组人数">
            <a-input placeholder="请输入每天入组人数" v-model="modelData.dailyEntryCount" class="input"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="关键词">
            <a-select mode="tags" @change="keywordChange" v-model='modelData.keywordList' placeholder='请选择' >
              <a-select-option :value='item' :key="item" v-for="item in modelData.keywordList">{{item}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="duration" label="时长">
            <a-input placeholder="请输入时长" v-model="modelData.duration" class="input"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="研究设计" prop="studyDesign">
            <a-select placeholder="请选择研究设计" v-model="studyDesignIds" showSearch mode="multiple" :filterOption="filterOption" @change="formItemIdChange">
              <a-select-option :value="item.id" v-for="(item, index) in researchDesignList" :key="index">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="研究类型" prop="studyType">
            <a-select placeholder="请选择研究类型" v-model="studyTypeIds" showSearch mode="multiple" :filterOption="filterOption" @change="formItemIdChange">
              <a-select-option :value="item.id" v-for="(item, index) in researchCategoryList" :key="index">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="研究设计说明" prop="studyDesignRemark" v-if="studyDesignIds.includes('6')">
            <a-input placeholder="请输入研究设计说明" v-model="studyDesignRemark" class="input"/>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item label="研究类型说明" prop="studyTypeRemark" v-if="studyTypeIds.includes('9')">
            <a-input placeholder="请输入研究类型说明" v-model="studyTypeRemark" class="input"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="remark" label="备注">
            <a-textarea :rows="4" placeholder="请输入备注" v-model="modelData.remark"  class="textarea" style="max-width: 233%; width: 233%;"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div style="float: right;">
      <a-button type="primary" style="margin-left: 10px;" @click="handleSubmit" icon="save">保存</a-button>
      <a-button type="primary" style="margin-left: 10px;" @click="handlePreview" icon="reload">预览</a-button>
      <a-button type="primary" style="margin-left: 10px;" @click="handleReport" icon="profile">报告</a-button>
    </div>
    <br/>
    <br/>
    <br/>
    <div style="width: 100%; text-align: center;">
      <h3>纳入排除标准</h3>
    </div>
    <CsimSchemaAttributeInclusionCriteria ref="CsimSchemaAttributeInclusionCriteria"/>
  </div>
</template>
<script>

import { getAction, postAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'
import { download } from "@/utils/util"

import CsimSchemaAttributeInclusionCriteria from "./CsimSchemaAttributeInclusionCriteria";

export default {
  name: "CsimSchemaAttributeForm",
  components: {
    CsimSchemaAttributeInclusionCriteria,
  },
  props: {
    model: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      modelData: {},
      studyDesignIds: [],
      studyTypeIds: [],
      rules: {
        departmentId: [baseRules.required],
        subSpecialtyId: [baseRules.required],
        diseaseTypeId: [baseRules.required],
      },
      diseaseList: [],
      subMajorList: [],
      deptList: [],
      researchDesignList: [
        { id: '1', name: '病例对照研究' },
        { id: '2', name: '队列研究' },
        { id: '3', name: '横断面研究' },
        { id: '4', name: '随机对照试验' },
        { id: '5', name: '应用盲文' },
        { id: '6', name: '其他' }
      ],
      researchCategoryList: [
        { id: '1', name: '伴随诊断试剂盒研究' },
        { id: '2', name: '既往临床数据回顾性研究' },
        { id: '3', name: '既往临床标本回顾性研究' },
        { id: '4', name: '建立标本库研究' },
        { id: '5', name: '建立队列研究' },
        { id: '6', name: 'I类临床新技术(安全性、有效性确切，技术难度低、几乎不存在伦理风险的医疗技术)' },
        { id: '7', name: '既往个案病例报道' },
        { id: '8', name: '非植入性医疗器械研究(面罩、牙垫等)' },
        { id: '9', name: '其他(研究者判定，请说明:)' },
      ],
      studyDesignRemark: "",
      studyTypeRemark: ""
    }
  },
  created () {
  },
  computed: {
    currentDeptOption() {
      // 根据value查找对应的选项对象
      return this.deptList.find(option => option.id === this.modelData.departmentId);
    },
    currentSubMajorOption() {
      // 根据value查找对应的选项对象
      return this.subMajorList.find(option => option.id === this.modelData.subSpecialtyId);
    },
    currentDiseaseOption() {
      // 根据value查找对应的选项对象
      return this.diseaseList.find(option => option.id === this.modelData.diseaseId);
    },
  },
  methods: {
    handleSetSchema(record) {
      this.modelData = record;

      let that = this;

      if (this.modelData.studyDesign) {
        this.studyDesignIds = JSON.parse(this.modelData.studyDesign).map(item => {
          if(item.id === '6'){
            that.studyDesignRemark = item.remark;
          }

          return item.id;
        });
      }
      if (this.modelData.studyType) {
        this.studyTypeIds = JSON.parse(this.modelData.studyType).map(item => {
          if(item.id === '9'){
            that.studyTypeRemark = item.remark;
          }

          return item.id;
        });
      }

      this.$nextTick(()=>{
        that.handleEditMy();
      })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    initDisease() {
      getAction('/tempconfig/tempConfigDisease/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.diseaseList = res.result.records
          // this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initDept() {
      getAction('/tempconfig/tempConfigDept/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.deptList = res.result.records
          this.deptList.unshift({ "id": "0", "name": "所有科室" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initSubMajor() {
      getAction('/tempconfig/tempConfigSubmajor/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.subMajorList = res.result.records
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    handleEditMy() {
      if (this.modelData.type == '2') {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }

      // this.initDisease()
      this.initDept()
      // this.initPeriod()
      // this.initSubMajor()

      this.deptChange(true)
      this.subMajorChange(true)
      // this.diseaseChange()

      if (this.modelData.id) {
        if (this.modelData.periodIdList && this.modelData.periodIdList.length > 0) {
          let periodList = []
          this.modelData.periodIdList.forEach(item => {
            periodList.push(item.id)
          })
          this.modelData.periodIdList = periodList
        }
      }

      this.$refs.CsimSchemaAttributeInclusionCriteria.handleSetSchema(this.modelData);
    },
    deptChange(firstTrigger) {
      // let selectedOption = this.currentDeptOption;
      getAction('/tempconfig/tempConfigSubmajor/queryByDeptId', { id: this.modelData.departmentId }).then(res => {
        if (res.success) {
          this.subMajorList = res.result
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        }
      })

      if (!firstTrigger) {
        this.modelData.subSpecialtyId = '0';
        this.modelData.diseaseTypeId = '0';
        this.$emit("handleSetSchema", this.modelData);
      }
    },
    subMajorChange(firstTrigger) {
      // let selectedOption = this.currentSubMajorOption;
      // console.log(selectedOption)
      getAction('/tempconfig/tempConfigDisease/queryByDeptIdAndSubMajorId', { deptId: this.modelData.departmentId, subMajorId: this.modelData.subSpecialtyId }).then(res => {
        if (res.success) {
          this.diseaseList = res.result
          this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        }
      })

      if (!firstTrigger) {
        this.modelData.diseaseTypeId = '0';
        this.$emit("handleSetSchema", this.modelData);
      }
    },
    diseaseChange(firstTrigger) {
      if (this.modelData.type!='1') {
        // let selectedOption = this.currentDiseaseOption;
        if (this.modelData.diseaseId === "0") {
          this.modelData.moduleId = "0"
        } else {
          getAction('/tempconfig/tempConfigModule/queryByDiseaseId', { diseaseId: this.modelData.diseaseId }).then(res => {
            if (res.success) {
              this.modelData.moduleId = res.result.id
            }
          })
        }
      }

      if (!firstTrigger) {
        this.$emit("handleSetSchema", this.modelData);
      }
    },
    keywordChange(){
      this.$set(this.modelData,'keyword',this.modelData.keywordList.join(','))
    },
    dummyValidator(rule, value, callback) {
      callback();
    },
    handleSubmit() {
      console.log('Submitting form with model:', this.modelData);

      let that = this;

      let studyDesign = this.studyDesignIds.map(id => {
        let result = { id: id, remark: "" };
        if (id === '6') {
          result.remark = that.studyDesignRemark;
        }

        return result;
      });
      let studyType = this.studyTypeIds.map(id => {
        let result = { id: id, remark: "" };
        if (id === '9') {
          result.remark = that.studyTypeRemark;
        }

        return result;
      });

      this.modelData.studyDesign = JSON.stringify(studyDesign);
      this.modelData.studyType = JSON.stringify(studyType);

      postAction('/scheme/save', this.modelData).then(res=>{
        if(res.success){
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      }).finally(()=>{
        // todo
        this.$emit("handleSetSchema", this.modelData);
      })
    },
    handlePreview() {
      console.log('Preview form: ', this.modelData.id);

      getAction('/scheme/view', { schemeId: this.modelData.id }).then(res => {
        if (res.success) {
          const previewUrl = window._CONFIG['staticDomainURL'] + "/" + res.result;
          console.log(previewUrl);

          download(previewUrl, this.modelData.schemeName + '.pdf');
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    handleReport() {
      console.log('Generating report');

      this.$message.warn("报告功能尚未实现");
    },
    getModelData() {
      return this.modelData;
    },
    formItemIdChange() {
      console.log('Form item ID changed');
      console.log(this.studyDesignIds);
      console.log(this.studyTypeIds);
    }
  }
};
</script>
